export default __webpack_public_path__ + "static/media/ProgressStage5.14120448.svg";